import { render } from "./GrigliaOperazioniStorico.vue?vue&type=template&id=71cf99b2"
import script from "./GrigliaOperazioniStorico.vue?vue&type=script&lang=js"
export * from "./GrigliaOperazioniStorico.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Ecommerce\\CONAD_MANUTENZIONI\\conad-manutenzioni\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__